import { InitPaymentSelectorParams, IPaymentService } from './IPaymentService';
import { AxiosInstance } from 'axios';

export class PaymentService implements IPaymentService {

    constructor(
        private readonly axios: AxiosInstance,
    ) {}

    public readonly initPaymentSelector = (params: InitPaymentSelectorParams): Promise<any> => {
        return this.axios.post('/api/payment-selector', params).then(res => {
            console.log('payment data', res.data);
            return res.data;
        });
    }

    public readonly getBulkPaymentRecord = (bulkPaymentId: string): Promise<any> => {
        return this.axios.get(`/bulk-payment/${bulkPaymentId}`).then(res => {
            console.log('payment data', res.data);
            return res.data;
        });
    }
}
